// redux/filterState.jsx

const initialState = {
  // filtering
  kategorie: "",
  ablageort: "",
  typ: "",
  land: "",
  material: "",
  waehrung: "",
  zustand: "",
  eigentuemer: "",

  // sorting
  sortField: "id",
  sortDirection: "asc",

  // pagination
  currentPage: 1,
  totalPages: 1,

  // range slider (year)
  jahrgangMin: "",
  jahrgangMax: "",
  jahrgangRangeMin: 1000,  // fallback value
  jahrgangRangeMax: new Date().getFullYear(),

  // default values from profil
  defaultKategorie: null,
};

export const setDefaultKategorie = (id) => ({
  type: "SET_DEFAULT_KATEGORIE",
  payload: id,
});

export const setFilter = (field, value) => ({
  type: "SET_FILTER",
  payload: { field, value }
});

export const resetFilters = () => ({
  type: "RESET_FILTERS"
});

export const setSort = (field, direction) => ({
  type: "SET_SORT",
  payload: { field, direction }
});

export const setCurrentPage = (page) => ({
  type: "SET_CURRENT_PAGE",
  payload: page,
});

export const setTotalPages = (count, page_size) => ({
  type: "SET_TOTAL_PAGES",
  payload: Math.ceil(count / page_size),
});

export const setJahrgangRange = (min, max) => {
  const [sortedMin, sortedMax] = [min, max].sort((a, b) => a - b);
  return {
    type: "SET_JAHRGANG_RANGE",
    payload: {
      min: sortedMin,
      max: sortedMax,
    }
  };
};

// REDUCER
const filterReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_FILTER":
      
      // debug
      // console.log(
      //   "SET_FILTER:",
      //   action.payload.field,
      //   action.payload.value
      // );

      if (state[action.payload.field] === action.payload.value) return state;
      return {
        ...state,
        [action.payload.field]: action.payload.value,
        currentPage:
          action.payload.field === "currentPage"
            ? action.payload.value
            : state.currentPage
      };

    case "SET_SORT":
      return {
        ...state,
        sortField: action.payload.field,
        sortDirection: action.payload.direction
      };

    case "SET_CURRENT_PAGE":
      return { ...state, currentPage: action.payload };

    case "SET_TOTAL_PAGES":
      if (state.totalPages === action.payload)
          return state;

      return { ...state, totalPages: action.payload };

    case "RESET_FILTERS":
      return {
        ...initialState,

        kategorie: state.defaultKategorie,
        defaultKategorie: state.defaultKategorie,
                
        sortField: state.sortField,
        sortDirection: state.sortDirection,

        jahrgangRangeMin: state.jahrgangRangeMin,
        jahrgangRangeMax: state.jahrgangRangeMax,

        jahrgangMin: state.jahrgangRangeMin.toString(),
        jahrgangMax: state.jahrgangRangeMax.toString(),
      };

    case "SET_JAHRGANG_RANGE":
      return {
        ...state,
        jahrgangRangeMin: action.payload.min,
        jahrgangRangeMax: action.payload.max,
      };

    case "RESET_APP_STATE":
      return { ...initialState }; // full reset for logout/login

    case "SET_DEFAULT_KATEGORIE":
      return {
        ...state,
        defaultKategorie: action.payload,
        kategorie: action.payload
      };

    case "SET_ALL":
      return {
        ...state,
        ...action.payload
      };

    default:
      return state;
  }
};

export default filterReducer;
